// Kompakter Sucheinstieg im Kanalkopf (Slot `channelHeader`): Absenden führt zur Suchseite mit Kanal-Bereich.
import { useId, useState } from 'react';
import { useNavigate } from 'react-router';
import type { ExtraContext } from '../index';
import { searchUrl } from './url';
import './search.css';

export function ChannelSearchButton({ serverId, channelId, onClose }: ExtraContext) {
  const navigate = useNavigate();
  const id = useId();
  const [value, setValue] = useState('');
  return (
    <form
      role="search"
      className="lfx-search-mini"
      data-testid="search-header"
      onSubmit={(e) => {
        e.preventDefault();
        void navigate(searchUrl({ q: value.trim(), server: serverId ?? null, channel: channelId ?? null }));
        setValue('');
        onClose?.();
      }}
    >
      <label htmlFor={id} className="lfx-search-sr-only">
        {channelId ? 'In diesem Kanal suchen' : 'Suchen'}
      </label>
      <input
        id={id}
        type="search"
        className="lfx-search-mini__input"
        placeholder="Suchen …"
        autoComplete="off"
        value={value}
        data-testid="search-header-input"
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Escape' && onClose) {
            e.preventDefault();
            onClose();
          }
        }}
      />
      <button type="submit" className="lfx-search-mini__btn" aria-label="Suche starten" data-testid="search-header-submit">
        <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">
          <circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" strokeWidth="2" />
          <path d="M15.5 15.5 21 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </button>
    </form>
  );
}
